export default __webpack_public_path__ + "static/media/2412302.aa182b10.webp";